/** @jsx jsx */
import { Box, Link, Flex, jsx, useColorMode } from "theme-ui"

const Footer = () => {
  const [colorMode] = useColorMode<"light" | "dark">()
  const isDark = colorMode === `dark`

  return (
    <Box as="footer" variant="layout.footer">
      Copyright Gewu/Elrignis {new Date().getFullYear()}. All rights reserved.
      <br />
      <Flex
        sx={{
          justifyContent: `center`,
          alignItems: `center`,
          mt: 3,
          color: `text`,
          fontWeight: `semibold`,
          a: { color: `text` },
        }}
      >
        {isDark ? (
          <img width="30" height="30" src="http://gugu.fun/img/gu_logo_w300_light.png" alt="GU Logo" />
        ) : (
          <img width="45" height="45" src="http://gugu.fun/img/gu_logo_w300.png" alt="GU Logo" />
        )}
        {` `}
        <Link
          aria-label="Link to the theme's GitHub repository"
          sx={{ ml: 2 }}
          href="https://github.com/LekoArts/gatsby-themes/tree/main/themes/gatsby-theme-emma"
        >
           
        </Link>
        <div sx={{ mx: 1 }}>苏ICP备20024692号-1</div>
        {` `}
        <Link
          aria-label="Link to the theme author's website"
          href="https://www.lekoarts.de?utm_source=emma&utm_medium=Theme"
        >
           
        </Link>

      </Flex>
      <Flex
        sx={{
          justifyContent: `center`,
          alignItems: `center`,
          mt: 3,
          color: `text`,
          fontWeight: `semibold`,
          a: { color: `text` },
        }}
      > {<img width="100%" src="http://gugu.fun/img/gu.gif" alt="GU_Logo_gif" />}</Flex>
    </Box>
  )
}

export default Footer
